import { Button } from "@/components/ui";
import { Download, FilesIcon, Trash2, X } from "lucide-react";

type FileBulkActionsProps = {
  canDelete?: boolean;
  downloadDisabled?: boolean;
  onClear: () => void;
  onDelete?: () => void;
  onDownload?: () => void;
  selectedCount: number;
};

export function FileBulkActions({
  canDelete = false,
  downloadDisabled = false,
  onClear,
  onDelete,
  onDownload,
  selectedCount,
}: FileBulkActionsProps) {
  return (
    <div className="border-t px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FilesIcon className="text-muted-foreground/60 h-7 w-7" />
          <div className="text-sm font-medium">{selectedCount} Selected</div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          type="button"
          onClick={onClear}
          title="Clear selection"
          className="h-7 w-7"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      {onDownload || onDelete ? (
        <div className="mt-3 flex items-center gap-2">
          {onDownload ? (
            <Button
              variant="outline"
              size="sm"
              type="button"
              onClick={onDownload}
              disabled={downloadDisabled}
            >
              <Download className="mr-2 h-4 w-4" />
              {downloadDisabled
                ? "Preparing download..."
                : `Download ${selectedCount}`}
            </Button>
          ) : null}
          {onDelete ? (
            <Button
              variant="outline"
              size="sm"
              type="button"
              disabled={!canDelete}
              onClick={onDelete}
              className="text-destructive"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Delete {selectedCount}
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
